import React from 'react';
import { connect } from 'react-redux';
import { getTenantState } from '../../../store/selectors';
import {
  getPopulationBySchool,
  getPopulationBySchoolCsv,
} from '../../../store/actions';
import Pagination from '../Pagination';
import SidebarTitle from '../basic-style-components/SidebarTitle';
import Loading from '../../utility/Loading';
import TitleAndData from '../basic-style-components/TitleAndData';
import { populationBySchool as copy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';

export class PopulationBySchool extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      schoolCounts: [],
      total: 0,
      resultPages: 1,
      currentPage: 1,
    };
  }

  getData = async (pageNumber = 1) => {
    const data = await this.props.getPopulationBySchool(pageNumber - 1);
    this.setState({
      loading: false,
      schoolCounts: data.schoolCounts,
      total: data.total,
      resultPages: data.resultPages,
    });
  };

  getCsv = async () => {
    const csvData = await this.props.getPopulationBySchoolCsv();
    return csvData;
  };

  componentDidMount = async () => {
    this.getData();
  };

  handlePageChange = async (pageNumber) => {
    if (pageNumber !== this.state.currentPage) {
      await this.setState({
        currentPage: pageNumber,
        loading: true,
      });
    }
    this.getData(pageNumber);
  };

  render() {
    const { loading, schoolCounts, total, currentPage, resultPages } =
      this.state;
    return (
      <div id="pop-by-school" className="pop-by-school">
        <SidebarTitle
          tenant={this.props.tenant}
          title={copy.heading1}
          csvCallback={this.getCsv}
          csvTitle="population-by-school"
        >
          {loading ? (
            <Loading height="615px" />
          ) : (
            <>
              <div className="pop-by-school__all-users">
                <TitleAndData
                  title={copy.subheading1}
                  data={total}
                  tenant={this.props.tenant}
                />
              </div>
              <div className="pop-by-school__by-school">
                {schoolCounts.map((x) => (
                  <div className="pop-by-school__quarter-width" key={x.school}>
                    <TitleAndData
                      title={x.school}
                      smallData
                      smallTitle
                      data={x.count}
                      tenant={this.props.tenant}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
          <Pagination
            handlePageChange={this.handlePageChange}
            currentPage={currentPage}
            resultPages={resultPages}
            primaryColor={this.props.tenant.primary}
          />
        </SidebarTitle>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  return { tenant };
}

export default connect(mapStateToProps, {
  getPopulationBySchool,
  getPopulationBySchoolCsv,
})(PopulationBySchool);
